RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.StatusListItem = views.ContentListItem.extend({
        template: '#contentStatusListItemTemplate'
    });

});
